// The Client Portal's static navigation, shared with the Admin Portal so its
// clients-list "Portal" dropdown lists the same pages the client sees.
// Module (add-on) pages are per-tenant and resolved by the Client Portal
// sidebar at runtime; they are deliberately not part of this static list.

export interface ClientPortalNavPage {
  label: string;
  href: string;
  /** The sidebar section the page renders under. */
  group: "root" | "content" | "website";
}

/** The always-visible Client Portal pages, in sidebar order. */
export const CLIENT_PORTAL_NAV: readonly ClientPortalNavPage[] = [
  { label: "Dashboard", href: "/", group: "root" },
  { label: "Pages", href: "/pages", group: "content" },
  { label: "Media", href: "/media", group: "content" },
  { label: "Navigation", href: "/menus", group: "website" },
  { label: "Forms", href: "/forms", group: "website" },
  { label: "Add-ons", href: "/modules", group: "website" },
  { label: "Billing", href: "/billing", group: "website" },
  { label: "Settings", href: "/settings", group: "website" },
];
